import Vue from 'vue'

import directives from './directives/index'
Vue.use(directives);
